const races_slider = () => {
    var race_swiper = new Swiper(".race-swiper", {
        slidesPerView: 2.4,
        spaceBetween: 30,
        allowTouchMove: false,
        navigation: {
            nextEl: ".next-race",
            prevEl: ".prev-race",
        },
        breakpoints: {
            0: {
                slidesPerView: 1.3,
                spaceBetween: 15,
            },
            992: {
                slidesPerView: 2.3,
                spaceBetween: 15,
            },
        },
    });

    var rangeProgress = document.getElementById('range-progress');

    const updateRangeThumbPosition = () => {
        const completionPercentage = race_swiper.progress * 100;
        const adjustedCompletion = (race_swiper.activeIndex === race_swiper.slides.length - 1) ? 100 : completionPercentage;

        rangeProgress.value = adjustedCompletion;

        const progress = rangeProgress.value;
        const trackColor = progress > 0 ? 'var(--darkred)' : '#cecece';
        rangeProgress.style.backgroundImage = `linear-gradient(to right, ${trackColor} 0%, ${trackColor} ${progress}%, #cecece ${progress}%, #cecece 100%)`;
    };

    document.querySelector('.swiper-button-next').addEventListener('click', () => {
        if (race_swiper.activeIndex < race_swiper.slides.length - 1) {
            race_swiper.slideNext();
            race_swiper.once('transitionEnd', updateRangeThumbPosition);
        }
    });

    document.querySelector('.swiper-button-prev').addEventListener('click', () => {
        if (race_swiper.activeIndex > 0) {
            race_swiper.slidePrev();
            race_swiper.once('transitionEnd', updateRangeThumbPosition);
        }
    });

    race_swiper.on('slideChange', updateRangeThumbPosition);
};

export default races_slider;
